import { $ as e, C as t, F as n, H as r, L as i, R as a, S as o, _ as s, b as c, f as ee, g as l, h as u, i as d, m as f, nt as te, ot as p, p as m, q as h, rt as g, t as _, v, w as y } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as b, t as x } from "./i18n-lite-BcmwMblk.js";
import { t as S } from "./normalize-props-DNjMoRjC.js";
import { t as C } from "./Retry-Bb7MddeE.js";
//#region src/webcomponents/capacity-calculation/locales/de-AT.json
var w = {}, T = {}, E = {}, D = {}, O = {}, k = { "capacity-calculation": {
	in: {
		aiQuestion: "Quelle est la demande à l’IA ?",
		aiOptions: {
			1: "Fais une vidéo d’une durée d’une minute.",
			2: "Écris un texte de 10 lignes.",
			3: "Fais un dessin de haute qualité."
		},
		userQuestion: "Combien d’utilisateurs font la demande en même temps ?",
		buttonLabel: {
			primary: "Observer l’effet",
			warning: "Recommencer"
		}
	},
	out: {
		title: "Impact des demandes",
		consumption: {
			label: "Consommation d’électricité :",
			normal_weak: "Moyenne",
			normal_medium: "Moyenne",
			warning: "Très forte",
			error: "Très forte",
			initial: "À l’arrêt"
		},
		capacity: {
			label: "État du centre de données :",
			normal_weak: "Normal",
			normal_medium: "Normal",
			warning: "Sollicitation maximale",
			error: "Ne peut pas répondre à la demande",
			initial: "À l’arrêt"
		}
	}
} }, A = {}, j = {}, M = /*#__PURE__*/ _(/* @__PURE__ */ y({
	__name: "Button.ce",
	props: {
		label: { type: String },
		state: { type: String }
	},
	setup(e) {
		return (t, r) => (n(), v("button", { class: g(["epreuve-button", e.state]) }, [a(t.$slots, "icon"), o(" " + p(e.label), 1)], 2));
	}
}), [["styles", [".epreuve-button{--pix-neutral-0:#fff;--pix-neutral-800:#253858;--pix-neutral-900:#122647;--pix-secondary-500:#ffcb33;--pix-secondary-700:#a16206}.epreuve-button.primary{--background-color:var(--pix-neutral-800);--background-color-hover:var(--pix-neutral-900);--color:var(--pix-neutral-0);--color-hover:var(--pix-neutral-0)}.epreuve-button.warning{--background-color:var(--pix-secondary-500);--background-color-hover:var(--pix-secondary-700);--color:var(--pix-neutral-900);--color-hover:var(--pix-neutral-0)}.epreuve-button.primary,.epreuve-button.warning{background-color:var(--background-color);color:var(--color);cursor:pointer;white-space:nowrap;border:2px solid #0000;border-radius:8px;outline:none;justify-content:center;align-items:center;gap:8px;width:fit-content;margin:0 auto;padding:8px 24px;font-family:Roboto,sans-serif;font-size:1rem;font-weight:700;line-height:24px;transition:background-color .5s,color .5s;display:flex}:is(.epreuve-button.primary,.epreuve-button.warning)[aria-disabled=true]{cursor:not-allowed;opacity:.5}:is(.epreuve-button.primary,.epreuve-button.warning):not([aria-disabled=true]):hover{background-color:var(--background-color-hover);color:var(--color-hover);transition:background-color .5s,color .5s}:is(.epreuve-button.primary,.epreuve-button.warning):not([aria-disabled=true]):hover svg{color:var(--color-hover);transition:color .5s}:is(.epreuve-button.primary,.epreuve-button.warning):focus,:is(.epreuve-button.primary,.epreuve-button.warning):focus-visible{background-color:var(--background-color-hover);color:var(--color-hover);outline:1px solid var(--pix-neutral-0);outline-offset:-5px}"]]]), N = { class: "capacity-calculation__column capacity-calculation__column--questions" }, P = { class: "capacity-calculation__fieldset capacity-calculation__fieldset--ai" }, F = { class: "capacity-calculation__legend" }, I = [
	"aria-disabled",
	"value",
	"checked"
], L = { class: "capacity-calculation__fieldset capacity-calculation__fieldset--range" }, R = { class: "capacity-calculation__legend--user-question" }, z = { class: "capacity-calculation__range-wrap" }, B = [
	"max",
	"value",
	"aria-disabled"
], V = {
	for: "nbUser",
	class: "capacity-calculation__range-label"
}, H = /*#__PURE__*/ _(/* @__PURE__ */ y({
	__name: "Questions.ce",
	props: {
		selectedAiQuestion: {
			type: Number,
			default: void 0
		},
		selectedAiQuestionModifiers: {},
		selectedNbUser: {
			type: Number,
			default: 10
		},
		selectedNbUserModifiers: {},
		currentLevel: {
			type: String,
			default: "initial"
		},
		currentLevelModifiers: {}
	},
	emits: [
		"update:selectedAiQuestion",
		"update:selectedNbUser",
		"update:currentLevel"
	],
	setup(a) {
		let { t: s } = b(), l = r(a, "selectedAiQuestion"), d = r(a, "selectedNbUser"), _ = r(a, "currentLevel"), y = f(() => [
			s("capacity-calculation.in.aiOptions.1"),
			s("capacity-calculation.in.aiOptions.2"),
			s("capacity-calculation.in.aiOptions.3")
		]), x = e(!1), S = f(() => ({
			state: _.value === "initial" ? "primary" : "warning",
			label: s(`capacity-calculation.in.buttonLabel.${_.value === "initial" ? "primary" : "warning"}`)
		})), w = f(() => Number.isInteger(l.value)), T = /* @__PURE__ */ new Set([
			10,
			20,
			30,
			40,
			50,
			60,
			70,
			80,
			90,
			100,
			200,
			300,
			400,
			500,
			600,
			700,
			800,
			1e3,
			2e3,
			3e3,
			4e3,
			5e3,
			1e4,
			800,
			8e3,
			14e3,
			25e3,
			9e4,
			15e4,
			2e4,
			3e4,
			4e4,
			5e4,
			75e3,
			1e5,
			125e3
		]), E = Array.from(T).sort((e, t) => e - t), D = f(() => {
			let e = E.indexOf(d.value);
			return Math.max(0, e);
		}), O = (e) => {
			let t = e.target;
			d.value = E[Number(t.value)];
		}, k = (e) => {
			if (x.value) {
				e.preventDefault();
				return;
			}
		}, A = () => {
			if (w.value) {
				if (_.value !== "initial") {
					H();
					return;
				}
				l.value === 0 ? d.value >= 10 && d.value <= 400 ? _.value = "normal_weak" : d.value >= 401 && d.value <= 700 ? _.value = "normal_medium" : d.value >= 701 && d.value <= 1e3 ? _.value = "warning" : _.value = "error" : l.value === 1 ? d.value >= 10 && d.value <= 4e4 ? _.value = "normal_weak" : d.value >= 40001 && d.value <= 7e4 ? _.value = "normal_medium" : d.value >= 70001 && d.value <= 1e5 ? _.value = "warning" : _.value = "error" : l.value === 2 && (d.value >= 10 && d.value <= 8e3 ? _.value = "normal_weak" : d.value >= 8001 && d.value <= 14e3 ? _.value = "normal_medium" : d.value >= 14001 && d.value <= 2e4 ? _.value = "warning" : _.value = "error"), x.value = !0;
			}
		};
		function j(e) {
			if (x.value) {
				e.preventDefault();
				return;
			}
			l.value = Number(e.target.value);
		}
		function H() {
			l.value = void 0, d.value = 10, _.value = "initial", x.value = !1;
		}
		return (e, r) => (n(), v("div", N, [
			u("fieldset", P, [u("legend", F, p(e.$t("capacity-calculation.in.aiQuestion")), 1), (n(!0), v(m, null, i(y.value, (e, t) => (n(), v("div", { key: t }, [u("label", { class: g(["capacity-calculation__ai-option", {
				"capacity-calculation__ai-option--active": l.value === t,
				disabled: x.value
			}]) }, [u("input", {
				type: "radio",
				"aria-disabled": x.value,
				name: "ai-answer",
				value: t,
				checked: l.value === t,
				onClick: j
			}, null, 8, I), o(" " + p(e), 1)], 2)]))), 128))]),
			u("fieldset", L, [u("legend", R, p(e.$t("capacity-calculation.in.userQuestion")), 1), u("div", z, [u("input", {
				id: "nbUser",
				type: "range",
				name: "nbUser",
				min: 0,
				max: te(E).length - 1,
				value: D.value,
				"aria-disabled": x.value,
				class: "capacity-calculation__range",
				onChange: O,
				onKeydown: k
			}, null, 40, B), u("label", V, p(d.value.toLocaleString()), 1)])]),
			t(M, {
				"aria-disabled": !w.value,
				label: S.value.label,
				state: S.value.state,
				onClick: ee(A, ["prevent"])
			}, c({ _: 2 }, [_.value === "initial" ? void 0 : {
				name: "icon",
				fn: h(() => [t(C)]),
				key: "0"
			}]), 1032, [
				"aria-disabled",
				"label",
				"state"
			])
		]));
	}
}), [["styles", [".capacity-calculation__column--questions[data-v-30a21361]{background:#fff;border:1px solid #cdd1d9}.capacity-calculation__column--questions .capacity-calculation__fieldset[data-v-30a21361]{border:none;flex-direction:column;gap:12px;padding:0;display:flex}.capacity-calculation__column--questions .capacity-calculation__fieldset--range[data-v-30a21361]{margin-top:12px}.capacity-calculation__column--questions .capacity-calculation__legend[data-v-30a21361]{margin-bottom:16px;font-weight:500}.capacity-calculation__column--questions .capacity-calculation__legend--user-question[data-v-30a21361]{margin:16px 0;font-weight:500}.capacity-calculation__column--questions .capacity-calculation__ai-option[data-v-30a21361]{cursor:pointer;border:1px solid #5e6c84;border-radius:8px;padding:12px;transition:all .2s;display:block}.capacity-calculation__column--questions .capacity-calculation__ai-option[data-v-30a21361]:hover,.capacity-calculation__column--questions .capacity-calculation__ai-option[data-v-30a21361]:focus,.capacity-calculation__column--questions .capacity-calculation__ai-option--active[data-v-30a21361]{color:#291a5d;background-color:#f7f5ff;border-color:#613fdd}.capacity-calculation__column--questions .capacity-calculation__ai-option.disabled[data-v-30a21361]{cursor:not-allowed;background:#f1f1f1;border-color:#5b5b5b}.capacity-calculation__column--questions .capacity-calculation__range-wrap[data-v-30a21361]{flex-direction:column;gap:8px;display:flex}.capacity-calculation__column--questions .capacity-calculation__range[data-v-30a21361]{accent-color:#613fdd;width:100%}.capacity-calculation__column--questions .capacity-calculation__range[aria-disabled=true][data-v-30a21361]{opacity:.3;pointer-events:none}.capacity-calculation__column--questions .capacity-calculation__range-label[data-v-30a21361]{justify-content:center;margin-block:-5px 10px;font-weight:700;display:flex}"]], ["__scopeId", "data-v-30a21361"]]), U = {}, W = {
	width: "43",
	height: "43",
	viewBox: "0 0 43 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true"
};
function G(e, t) {
	return n(), v("svg", W, [...t[0] ||= [u("path", {
		d: "M21.5001 24.1262L26.5243 29.1505C26.8743 29.5004 27.3121 29.6736 27.8376 29.6701C28.3632 29.6665 28.8008 29.4898 29.1505 29.1402C29.5004 28.7902 29.6754 28.3524 29.6754 27.8269C29.6754 27.3013 29.5004 26.8636 29.1505 26.5136L24.1262 21.5001L29.1505 16.4758C29.5004 16.1258 29.6754 15.688 29.6754 15.1625C29.6754 14.6369 29.5004 14.1993 29.1505 13.8496C28.8008 13.4997 28.3632 13.3247 27.8376 13.3247C27.3121 13.3247 26.8743 13.4997 26.5243 13.8496L21.5001 18.8739L16.4758 13.8496C16.1258 13.4997 15.6898 13.3247 15.1679 13.3247C14.6459 13.3247 14.2099 13.4997 13.8599 13.8496C13.5103 14.1993 13.3354 14.6369 13.3354 15.1625C13.3354 15.688 13.5103 16.1258 13.8599 16.4758L18.8739 21.5001L13.8496 26.5243C13.4997 26.8743 13.3265 27.3103 13.3301 27.8323C13.3336 28.3542 13.5103 28.7902 13.8599 29.1402C14.2099 29.4898 14.6477 29.6647 15.1732 29.6647C15.6988 29.6647 16.1366 29.4898 16.4865 29.1402L21.5001 24.1262ZM21.5001 39.7809C18.9646 39.7809 16.5854 39.3016 14.3625 38.3431C12.1399 37.3845 10.2063 36.083 8.56154 34.4386C6.91709 32.7938 5.61559 30.8602 4.65705 28.6376C3.69851 26.4148 3.21924 24.0356 3.21924 21.5001C3.21924 18.9646 3.69851 16.5854 4.65705 14.3625C5.61559 12.1399 6.91709 10.2063 8.56154 8.56154C10.2063 6.91709 12.1399 5.61559 14.3625 4.65705C16.5854 3.69851 18.9646 3.21924 21.5001 3.21924C24.0356 3.21924 26.4148 3.69851 28.6376 4.65705C30.8602 5.61559 32.7938 6.91709 34.4386 8.56154C36.083 10.2063 37.3845 12.1399 38.3431 14.3625C39.3016 16.5854 39.7809 18.9646 39.7809 21.5001C39.7809 24.0356 39.3016 26.4148 38.3431 28.6376C37.3845 30.8602 36.083 32.7938 34.4386 34.4386C32.7938 36.083 30.8602 37.3845 28.6376 38.3431C26.4148 39.3016 24.0356 39.7809 21.5001 39.7809Z",
		fill: "#D24140"
	}, null, -1)]]);
}
var K = /*#__PURE__*/ _(U, [["render", G]]), q = {}, J = {
	width: "43",
	height: "43",
	viewBox: "0 0 43 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true"
};
function ne(e, t) {
	return n(), v("svg", J, [...t[0] ||= [u("path", {
		d: "M18.9595 24.3502L15.386 20.7767C15.0148 20.4052 14.5468 20.2195 13.9818 20.2195C13.4171 20.2195 12.949 20.4052 12.5776 20.7767C12.2064 21.1479 12.0226 21.6159 12.0262 22.1809C12.0298 22.7456 12.2171 23.2135 12.5883 23.5847L17.5235 28.5198C17.9343 28.928 18.4138 29.1321 18.9617 29.1321C19.5094 29.1321 19.9874 28.928 20.3959 28.5198L30.3581 18.5572C30.7295 18.1861 30.9153 17.7199 30.9153 17.1589C30.9153 16.5975 30.7295 16.1312 30.3581 15.76C29.9869 15.3885 29.5188 15.2028 28.9538 15.2028C28.3892 15.2028 27.9212 15.3885 27.5501 15.76L18.9595 24.3502ZM21.5001 39.7809C18.9646 39.7809 16.5855 39.3013 14.363 38.3422C12.1401 37.383 10.2066 36.0815 8.56244 34.4377C6.91858 32.7935 5.61709 30.86 4.65795 28.6372C3.69881 26.4146 3.21924 24.0356 3.21924 21.5001C3.21924 18.9646 3.69881 16.5855 4.65795 14.363C5.61709 12.1401 6.91858 10.2066 8.56244 8.56244C10.2066 6.91858 12.1401 5.61709 14.363 4.65795C16.5855 3.69881 18.9646 3.21924 21.5001 3.21924C24.0356 3.21924 26.4146 3.69881 28.6372 4.65795C30.86 5.61709 32.7935 6.91858 34.4377 8.56244C36.0815 10.2066 37.383 12.1401 38.3422 14.363C39.3013 16.5855 39.7809 18.9646 39.7809 21.5001C39.7809 24.0356 39.3013 26.4146 38.3422 28.6372C37.383 30.86 36.0815 32.7935 34.4377 34.4377C32.7935 36.0815 30.86 37.383 28.6372 38.3422C26.4146 39.3013 24.0356 39.7809 21.5001 39.7809Z",
		fill: "#1f53b5"
	}, null, -1)]]);
}
var Y = /*#__PURE__*/ _(q, [["render", ne]]), X = {}, Z = {
	width: "43",
	height: "43",
	viewBox: "0 0 43 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true"
};
function re(e, t) {
	return n(), v("svg", Z, [...t[0] ||= [u("path", {
		d: "M5.00009 37.8074C4.62175 37.8074 4.27999 37.7135 3.9748 37.5257C3.66962 37.3379 3.43238 37.0903 3.26307 36.783C3.09226 36.4785 2.99939 36.1476 2.98446 35.7905C2.96953 35.4333 3.0624 35.0848 3.26307 34.745L19.7182 6.27096C19.9186 5.92965 20.1806 5.67538 20.5043 5.50816C20.828 5.34093 21.1602 5.25732 21.5009 5.25732C21.8416 5.25732 22.1735 5.34093 22.4966 5.50816C22.8197 5.67538 23.0814 5.92965 23.2818 6.27096L39.7369 34.745C39.9376 35.0848 40.0305 35.4333 40.0155 35.7905C40.0006 36.1476 39.9077 36.4785 39.7369 36.783C39.5661 37.0873 39.3286 37.3341 39.0243 37.5234C38.7197 37.7128 38.3782 37.8074 37.9999 37.8074H5.00009ZM21.5 32.2179C22.0148 32.2179 22.4511 32.039 22.8088 31.6813C23.1665 31.3238 23.3454 30.8877 23.3454 30.3729C23.3454 29.8581 23.1665 29.4236 22.8088 29.0695C22.4511 28.7153 22.0148 28.5382 21.5 28.5382C20.9852 28.5382 20.5489 28.7153 20.1912 29.0695C19.8334 29.4236 19.6546 29.8581 19.6546 30.3729C19.6546 30.8877 19.8334 31.3238 20.1912 31.6813C20.5489 32.039 20.9852 32.2179 21.5 32.2179ZM21.5 26.8751C22.0076 26.8751 22.4332 26.7034 22.7766 26.36C23.12 26.0166 23.2917 25.5911 23.2917 25.0835V19.8263C23.2917 19.3186 23.12 18.8931 22.7766 18.5497C22.4332 18.2063 22.0076 18.0346 21.5 18.0346C20.9924 18.0346 20.5668 18.2063 20.2234 18.5497C19.88 18.8931 19.7083 19.3186 19.7083 19.8263V25.0835C19.7083 25.5911 19.88 26.0166 20.2234 26.36C20.5668 26.7034 20.9924 26.8751 21.5 26.8751Z",
		fill: "#EE6911"
	}, null, -1)]]);
}
var ie = /*#__PURE__*/ _(X, [["render", re]]), ae = ["aria-level"], oe = { class: "capacity-calculation__card" }, se = { class: "capacity-calculation__text capacity-calculation__text--strong" }, ce = { class: "capacity-calculation__img" }, le = ["src"], ue = { class: "capacity-calculation__text" }, de = { class: "capacity-calculation__answers" }, fe = { class: "capacity-calculation__card" }, pe = { class: "capacity-calculation__text capacity-calculation__text--strong" }, me = { class: "capacity-calculation__text" }, Q = /*#__PURE__*/ _(/* @__PURE__ */ y({
	__name: "Answers.ce",
	props: {
		currentLevel: { type: String },
		selectedNbUser: { type: Number },
		titleLevel: { type: Number },
		capacityImage: { type: String }
	},
	setup(e) {
		return (t, r) => (n(), v("div", { class: g(["capacity-calculation__column capacity-calculation__column--answers", { [`capacity-calculation__column--answers--${e.currentLevel}`]: !0 }]) }, [
			u("div", {
				role: "heading",
				"aria-level": e.titleLevel,
				class: "capacity-calculation__title"
			}, p(t.$t("capacity-calculation.out.title")), 9, ae),
			u("div", oe, [
				u("p", se, p(t.$t("capacity-calculation.out.capacity.label")), 1),
				u("div", ce, [u("img", {
					src: e.capacityImage,
					alt: ""
				}, null, 8, le), e.currentLevel.startsWith("normal_") ? (n(), l(Y, {
					key: 0,
					class: "capacity-calculation__img--status"
				})) : e.currentLevel === "warning" ? (n(), l(ie, {
					key: 1,
					class: "capacity-calculation__img--status"
				})) : e.currentLevel === "error" ? (n(), l(K, {
					key: 2,
					class: "capacity-calculation__img--status"
				})) : s("", !0)]),
				u("p", ue, p(t.$t(`capacity-calculation.out.capacity.${e.currentLevel}`)), 1)
			]),
			u("div", de, [u("div", fe, [
				u("p", pe, p(t.$t("capacity-calculation.out.consumption.label")), 1),
				u("div", { class: g(["capacity-calculation__progress-bar", e.currentLevel]) }, null, 2),
				u("p", me, p(t.$t(`capacity-calculation.out.consumption.${e.currentLevel}`)), 1)
			])])
		], 2));
	}
}), [["styles", [".capacity-calculation__column--answers[data-v-51d8db7d]{border:0;gap:.3rem;display:flex}.capacity-calculation__column--answers--normal_weak[data-v-51d8db7d],.capacity-calculation__column--answers--normal_medium[data-v-51d8db7d]{background:#eaf1ff}.capacity-calculation__column--answers--warning[data-v-51d8db7d]{background:#fffaeb}.capacity-calculation__column--answers--error[data-v-51d8db7d]{background:#fbebea}.capacity-calculation__column--answers .capacity-calculation__answers[data-v-51d8db7d]{flex-direction:column;justify-content:center;align-items:stretch;gap:8px;margin-bottom:1rem;display:flex}.capacity-calculation__column--answers .capacity-calculation__card[data-v-51d8db7d]{border-radius:4px;flex-direction:column;align-items:center;gap:16px;padding:8px;display:flex}.capacity-calculation__column--answers .capacity-calculation__text[data-v-51d8db7d]{text-align:center;margin:0;font-size:.875rem;font-weight:400;line-height:1.5rem}.capacity-calculation__column--answers .capacity-calculation__text--strong[data-v-51d8db7d]{margin:0;font-weight:700}.capacity-calculation__column--answers img[data-v-51d8db7d]{max-width:100%}.capacity-calculation__column--answers .capacity-calculation__img[data-v-51d8db7d]{position:relative}.capacity-calculation__column--answers .capacity-calculation__img img[data-v-51d8db7d]{border-radius:24px;width:100px;height:100px}.capacity-calculation__column--answers .capacity-calculation__img--status[data-v-51d8db7d]{position:absolute;top:0;right:0;transform:translate(30%,-30%)}.capacity-calculation__column--answers .capacity-calculation__progress-bar[data-v-51d8db7d]{border:2px solid #253858;border-radius:24px;width:100%;height:32px}.capacity-calculation__column--answers .capacity-calculation__progress-bar.normal_weak[data-v-51d8db7d],.capacity-calculation__column--answers .capacity-calculation__progress-bar.normal_medium[data-v-51d8db7d]{background:linear-gradient(90deg,#1f53b5 10%,#fff 36%)}.capacity-calculation__column--answers .capacity-calculation__progress-bar.warning[data-v-51d8db7d]{background:linear-gradient(90deg,#ee6911 30%,#fff 66%)}.capacity-calculation__column--answers .capacity-calculation__progress-bar.error[data-v-51d8db7d]{background:linear-gradient(90deg,#d24140 51%,#fff 88%)}@media (width<=720px){.capacity-calculation__column--answers .capacity-calculation__answers[data-v-51d8db7d]{flex-direction:row;justify-content:center;gap:16px}}"]], ["__scopeId", "data-v-51d8db7d"]]), he = { class: "capacity-calculation" }, ge = {
	class: "capacity-calculation__grid",
	"aria-live": "polite"
}, _e = /*#__PURE__*/ _(/* @__PURE__ */ y({
	__name: "CapacityCalculation.ce",
	props: {
		titleLevel: {
			default: 2,
			type: Number
		},
		capacityImage: { type: String }
	},
	setup(r) {
		let i = e(void 0), a = e(10), o = e("initial");
		return (e, c) => (n(), v("div", he, [u("div", ge, [t(H, {
			"selected-ai-question": i.value,
			"onUpdate:selectedAiQuestion": c[0] ||= (e) => i.value = e,
			"selected-nb-user": a.value,
			"onUpdate:selectedNbUser": c[1] ||= (e) => a.value = e,
			"current-level": o.value,
			"onUpdate:currentLevel": c[2] ||= (e) => o.value = e,
			class: g({ "initial-state": o.value === "initial" })
		}, null, 8, [
			"selected-ai-question",
			"selected-nb-user",
			"current-level",
			"class"
		]), o.value === "initial" ? s("", !0) : (n(), l(Q, {
			key: 0,
			"title-level": r.titleLevel,
			"selected-nb-user": a.value,
			"current-level": o.value,
			"capacity-image": r.capacityImage
		}, null, 8, [
			"title-level",
			"selected-nb-user",
			"current-level",
			"capacity-image"
		]))])]));
	}
}), [["styles", [".capacity-calculation__title{color:#122647;text-align:center;margin-bottom:1rem;font-family:Nunito,serif;font-size:1.25rem;font-weight:700;line-height:1.75rem}.capacity-calculation__grid{grid-template-columns:5fr 2.6fr;gap:1rem;display:grid}.capacity-calculation__grid .initial-state{grid-column:1/span 2}.capacity-calculation__column{border-radius:8px;flex-direction:column;padding:16px;display:flex}@media screen and (width<=720px){.capacity-calculation__grid{flex-direction:column;display:flex}}"]]]);
//#endregion
//#region src/webcomponents/capacity-calculation/capacity-calculation.ce.js
x.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": w,
	"./locales/en.json": T,
	"./locales/es-419.json": E,
	"./locales/es.json": D,
	"./locales/fr-BE.json": O,
	"./locales/fr.json": k,
	"./locales/it.json": A,
	"./locales/nl.json": j
}));
var $ = d(_e, { configureApp(e) {
	x.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(x);
} });
$.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: S(e.titleLevel)
}), window.customElements.define("capacity-calculation", $);
//#endregion
